export default {
  namespaced: true,
  state: {
    items: {
      registration: [
        {
          name: "faq_registration_1_name",
          description: "faq_registration_1_description",
          linkedText: "faq_registration_1_linkedText",
          link:
            "https://www.sympatia.sk/wp-content/uploads/2020/11/Cenník-pre-riadenie-portfólia_FO-od-1.5.2019-1.pdf"
        },
        {
          name: "faq_registration_2_name",
          description: "faq_registration_2_description"
        },
        {
          name: "faq_registration_3_name",
          description: "faq_registration_3_description"
        }
      ],
      login: [
        {
          name: "faq_login_1_name",
          description: "faq_login_1_description"
        },
        {
          name: "faq_login_2_name",
          description: "faq_login_2_description"
        }
      ],
      personalInfo: [
        {
          name: "faq_personalInfo_1_name",
          description: "faq_personalInfo_1_description"
        },
        {
          name: "faq_personalInfo_2_name",
          description: "faq_personalInfo_2_description"
        },
        {
          name: "faq_personalInfo_3_name",
          description: "faq_personalInfo_3_description",
          linkedText: "faq_personalInfo_3_linkedText",
          link: "https://www.sympatia.sk/gdpr/"
        }
      ],
      investmentQuestionnaire: [
        {
          name: "faq_investmentQuestionnaire_1_name",
          description: "faq_investmentQuestionnaire_1_description"
        }
      ],
      selectStrategy: [
        {
          name: "faq_selectStrategy_1_name",
          description: "faq_selectStrategy_1_description"
        },
        {
          name: "faq_selectStrategy_2_name",
          description: "faq_selectStrategy_2_description"
        }
      ],
      documents: [
        {
          name: "faq_documents_1_name",
          description: "faq_documents_1_description"
        }
      ]
    }
  },
  getters: {},
  actions: {},
  mutations: {}
};
